import React, { Component } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import contactAnimationData from '../helper/starproduct.json'
import Lottie from 'react-lottie';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: contactAnimationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

export default class AnimationStar extends Component {
    render() {
        return (
            <div style={{
                alignSelf: 'center',
                flexDirection: "column",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color:'red'

            }}>
                {/* <span style={{ fontSize: 20, color: "#616161" }}>ກໍາລັງໂຫຼດ...</span> */}
                <Lottie options={defaultOptions} width={200}  />
            </div>
        )
    }
}
